import { render, staticRenderFns } from "./DeckResetForm.vue?vue&type=template&id=24b1cd59&"
import script from "./DeckResetForm.vue?vue&type=script&lang=js&"
export * from "./DeckResetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports